interface RatingProps {
  value: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-lg',
};

export default function Rating({ value, size = 'sm', className = '' }: RatingProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 font-label font-semibold text-accent-600 ${sizeMap[size]} ${className}`}
    >
      <i className="ri-star-fill" aria-hidden="true" />
      {value.toFixed(1)}
    </span>
  );
}